/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonials_TitleInputs */

const en_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for accuracy, not hype`)
};

const de_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebaut für Genauigkeit, nicht für Hype`)
};

const fr_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu pour la précision, pas pour le battage`)
};

const es_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construido para la precisión, no para el bombo`)
};

const it_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruito per la precisione, non per il clamore`)
};

const nl_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebouwd voor nauwkeurigheid, niet voor hype`)
};

const pl_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbudowane dla precyzji, nie dla szumu`)
};

const fi_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakennettu tarkkuudelle, ei hypetykselle`)
};

const da_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til præcision, ikke hype`)
};

const sv_landing_testimonials_title = /** @type {(inputs: Landing_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggt för precision, inte för hajp`)
};

/**
* | output |
* | --- |
* | "Built for accuracy, not hype" |
*
* @param {Landing_Testimonials_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonials_title = /** @type {((inputs?: Landing_Testimonials_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonials_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonials_title(inputs)
	if (locale === "fr") return fr_landing_testimonials_title(inputs)
	if (locale === "es") return es_landing_testimonials_title(inputs)
	if (locale === "it") return it_landing_testimonials_title(inputs)
	if (locale === "nl") return nl_landing_testimonials_title(inputs)
	if (locale === "pl") return pl_landing_testimonials_title(inputs)
	if (locale === "fi") return fi_landing_testimonials_title(inputs)
	if (locale === "da") return da_landing_testimonials_title(inputs)
	if (locale === "sv") return sv_landing_testimonials_title(inputs)
	return en_landing_testimonials_title(inputs)
});